import axios from 'axios'

const instance = axios.create({
  timeout: 10000
})
// 开发环境不设置 baseURL，依赖代理；生产环境动态设置
if (process.env.NODE_ENV === 'production') {
  instance.defaults.baseURL = process.env.VUE_APP_API_BASE_URL
}
export default instance